import { render, staticRenderFns } from "./managementStandardOfFranchiseeGY.vue?vue&type=template&id=3fc2f364&scoped=true"
import script from "./managementStandardOfFranchiseeGY.vue?vue&type=script&lang=js"
export * from "./managementStandardOfFranchiseeGY.vue?vue&type=script&lang=js"
import style0 from "./managementStandardOfFranchiseeGY.vue?vue&type=style&index=0&id=3fc2f364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2f364",
  null
  
)

export default component.exports